import { Model } from '@psyomics/surveyjs-core';
import { z } from 'zod';

const CONTENT_QUESTION_TYPES = Object.freeze(['html', 'image']);
const FREE_TEXT_QUESTION_TYPES = Object.freeze(['text', 'comment']);

type Survey = {
  code: string;
  definition: unknown;
  id: string;
  model: Model;
  name: string;
  version: string;
  respondentType: string;
};

type SurveySet = Survey[];

type SurveyWithoutModel = Omit<Survey, 'model'>;
type SurveySetWithoutModel = SurveyWithoutModel[];

const answersSchema = z.record(z.string(), z.union([z.string(), z.array(z.string()), z.number(), z.undefined()]));

const supportedAnswerFormatSchema = z.record(z.string(), answersSchema);

type Answers = z.infer<typeof answersSchema>;
type AnswersByRespondentType = Record<string, Answers>;
type SupportedAnswerFormat = z.infer<typeof supportedAnswerFormatSchema>;

export type {
  Answers,
  AnswersByRespondentType,
  SupportedAnswerFormat,
  Survey,
  SurveySet,
  SurveySetWithoutModel,
  SurveyWithoutModel,
};

export { answersSchema, CONTENT_QUESTION_TYPES, FREE_TEXT_QUESTION_TYPES, supportedAnswerFormatSchema };
